import moment from 'moment/moment';
import React from 'react'
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import constant from '../../utils/constant';
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';

const isEmptyString = (value) => {
  if (value == null) {
    return false;
  }
  return !(String(value).trim().length === 0);
};

const Modern_template_2 = ({document_number, business_detail, document_issue_date, document_due_date, client_detail, items, discount, discount_type, discount_amount, tax_amount, tax_type, tax_label, document_note, template, action, total_document_amount, document_tax, document_tax_amount, document_discount_type, document_discount, document_discount_amount, document_currency, document_type, user_notification_token, localization, signature_name, signature}) => {
  const business_detaill=JSON.parse(business_detail) || {};
  const itemss=JSON.parse(items) || [];
  const client_detaill=JSON.parse(client_detail) || {};
  const document_currencyy=JSON.parse(document_currency) || {};
  const templatee=JSON.parse(template) || {};
  const localizationn=localization=="zh"?zh:localization=="de"?de:localization=="en"?en:localization=="es"?es:localization=="fr"?fr:localization=="it"?it:localization=="pt"?pt:en;
  
  return (
    <div className="w-full relative" style={{backgroundColor:templatee?.selectedcolor?.primary}}>
      <div className='w-full h-[40px] md:h-[60px] flex overflow-hidden' style={{backgroundColor:templatee?.selectedcolor?.primary}}>
        <div className='flex flex-1' style={{marginLeft:-18,transform:'skewX(20deg)' ,backgroundColor:templatee?.selectedcolor?.third}}/>
        <div className='w-[70%] h-full' style={{marginRight:-20,transform:'skewX(20deg)',backgroundColor:templatee?.selectedcolor?.secondary}}/>
      </div>
      <div className='absolute bottom-0 w-full h-[40px] md:h-[60px] flex overflow-hidden' style={{backgroundColor:templatee?.selectedcolor?.primary}}>
        <div className='flex flex-1' style={{marginLeft:-18,transform:'skewX(-20deg)' ,backgroundColor:templatee?.selectedcolor?.third}}/>
        <div className='w-[40%] h-full' style={{marginRight:-20,transform:'skewX(-20deg)',backgroundColor:templatee?.selectedcolor?.secondary}}/>
      </div>
      <div className='w-full flex justify-between mt-5 px-2 md:px-4'>
        <div className="shrink-0 mt-2 mb-5 overflow-hidden flex justify-center items-center">
            {business_detaill?.business_logo.trim()?(
                <img src={business_detaill?.business_logo} className="w-20 h-20 md:w-40 md:h-40" />
            ):(
                <div className="w-20 h-20 md:w-40 md:h-40" />
            )}
        </div>
        <div className='w-1/2 h-full flex justify-end'>
          <div className='p-3 rounded' style={{backgroundColor:templatee?.selectedcolor?.secondary}}>
              <h1 className="text-2xl md:text-4xl tracking-tight sf-semibold break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_type === 'estimate' ? localizationn?.estimate_full_capital : localizationn?.invoice_full_capital}</h1>
              <div className='flex justify-between'>
                <p className="sf-regular text-[10px] md:text-base break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_type === 'estimate' ? localizationn?.estimate_no : localizationn?.invoice_no}</p>
                <p className="sf-regular text-[10px] md:text-base break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_number}</p>
              </div>
          </div>
        </div>
      </div>
      <div className='w-full flex mt-5 px-2 md:px-4'>
        <div className='w-[37%]'>
          <h2 className="text-base md:text-xl sf-semibold" style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.from}</h2>
          <p className="sf-regular text-[10px] md:text-xl" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_name}</p>
          {isEmptyString(business_detaill?.business_street_1)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_street_1}</p>)}
          {isEmptyString(business_detaill?.business_phone_1)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_phone_1}</p>)}
          {isEmptyString(business_detaill?.business_phone_2)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_phone_2}</p>)}
          {isEmptyString(business_detaill?.business_country)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_country}</p>)}
          {isEmptyString(business_detaill?.business_city)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_city}</p>)}
          {isEmptyString(business_detaill?.business_email)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{business_detaill?.business_email}</p>)}
        </div>
        <div className='w-[37%]'>
          <h2 className="text-base md:text-xl sf-semibold" style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.bill_to}</h2>
          {isEmptyString(client_detaill?.client_name)&&(<p className="sf-regular text-[10px] md:text-xl" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_name}</p>)}
          {isEmptyString(client_detaill?.client_address_1)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_address_1}</p>)}
          {isEmptyString(client_detaill?.client_phone)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_phone}</p>)}
          {isEmptyString(client_detaill?.client_mobile)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_mobile}</p>)}
          {isEmptyString(client_detaill?.client_country)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_country}</p>)}
          {isEmptyString(client_detaill?.client_city)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_city} {client_detaill?.client_zip.trim()!=""&&(" - "+client_detaill?.client_zip)}</p>)}
          {isEmptyString(client_detaill?.client_email)&&(<p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{client_detaill?.client_email}</p>)}
        </div>
        <div className='w-[26%] flex flex-col justify-end'>
          <div className='flex justify-start flex-wrap'>
            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{localizationn?.issued}: </p>
            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>&nbsp;{moment(document_issue_date).format('MMM,DD,YYYY')}</p>
          </div>
          <div className='flex justify-start flex-wrap'>
            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor2}}>{document_type === 'estimate' ? localizationn?.valid_until : localizationn?.due_date} </p>
            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>&nbsp;{moment(document_due_date).isValid() ? moment(document_due_date).format("MMM,DD,YYYY") : 
                document_due_date=="On Receipt"?localizationn?.on_receipt:
                document_due_date=="3 days"?localizationn?.three_days:
                document_due_date=="10 days"?localizationn?.ten_days:
                document_due_date=="30 days"?localizationn?.thirty_days:
                document_due_date=="No Valid Date"?localizationn?.no_valid_date:
                document_due_date=="No Duo Date"?localizationn?.no_duo_date:
                document_due_date
            }</p>
          </div>
        </div>
      </div>
      {/* Table */}
      <div className="mt-4 overflow-hidden mx-2 md:mx-4">
            <table className="w-full text-[8px] md:text-base">
              <thead>
                {/* No background on the TR anymore */}
                <tr style={{color:templatee?.selectedcolor?.tableheadercolor}}>
                    {/* DESCRIPTION */}
                    <th className="p-0 align-middle border-none">
                        <div 
                            className=" py-2 px-3 text-center sf-medium rounded-md" 
                            style={{backgroundColor: templatee?.selectedcolor?.secondary}}
                        >
                            {localizationn?.description}
                        </div>
                    </th>
                    {/* QUANTITY */}
                    <th className="p-0 align-middle border-none">
                        <div 
                            className="mx-1 py-2 px-3 text-center sf-medium rounded-md" 
                            style={{backgroundColor: templatee?.selectedcolor?.secondary}}
                        >
                            {localizationn?.quantity_up}
                        </div>
                    </th>
                    {/* UNIT PRICE */}
                    <th className="p-0 align-middle border-none">
                        <div 
                            className="mr-1 py-2 px-3 text-center sf-medium rounded-md" 
                            style={{backgroundColor: templatee?.selectedcolor?.secondary}}
                        >
                            {localizationn?.unit_price}
                        </div>
                    </th>

                    {/* TOTAL */}
                    <th className="p-0 align-middle border-none">
                        <div 
                            className="py-2 px-3 text-center sf-medium rounded-md" 
                            style={{backgroundColor: templatee?.selectedcolor?.secondary}}
                        >
                            {localizationn?.total}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemss?.map((item,index)=>(
                    <tr key={index} className='border-b' style={{borderColor:templatee?.selectedcolor?.bordercolor, color:templatee?.selectedcolor?.textcolor}}>
                        <td className="py-2 px-3 text-center sf-bold">{item?.item_name}</td>
                        <td className="py-2 px-3 text-center sf-regular">{numberbeautify(item?.item_quantity)}{item?.item_type == 'service' ? "/"+item?.item_unit_type : null}</td>
                        <td className="py-2 px-3 text-center sf-regular">{document_currencyy?.symbol}{numberbeautify(item?.item_price)}</td>
                        <td className="py-2 px-3 text-center sf-regular">{document_currencyy?.symbol}{numberbeautify(money_rounding(Number(item?.item_price) * Number(item?.item_quantity)))}</td>
                    </tr>
                ))}
            </tbody>
            </table>
        </div>
        <div className='w-full flex justify-between mt-2 md:mt-5 px-2 md:px-4'>
            <div className='w-1/2 flex flex-col justify-end items-start' style={{color:templatee?.selectedcolor?.textcolor}}>
                {document_note.trim()!==""&&document_note}
            </div>
            <div className='w-1/2'>
                <div className='w-full flex justify-end py-[5px] px-2'>
                    <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.sub_total}</p>
                    <p className='w-1/2 text-right sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                    {
                        numberbeautify(
                            money_rounding(
                                itemss?.reduce((total, item) => total + (Number(item.item_price) * Number(item.item_quantity)), 0)
                            )
                        )
                    }</p>
                </div>
                <div className='w-full flex justify-end py-[5px] px-2'>
                    <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.discount}: {discount} {discount_type == 'percent' ? '%' : document_currencyy?.symbol}</p>
                    <p className='w-1/2 text-right sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                    {discount_type=='percent'?
                        numberbeautify(money_rounding(itemss?.reduce((total, item) => Number(total) + ((Number(item.item_price) * Number(item.item_quantity) * (Number(discount) / 100))),0))):
                        numberbeautify(money_rounding(discount))
                    }</p>
                </div>
                <div className='w-full flex justify-end py-[5px] px-2'>
                    <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{tax_label}: {tax_amount}%</p>
                    <p className='w-1/2 text-right sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                    {(() => {
                        const items = itemss || [];
                        const discountType = discount_type;
                        const discountValue = Number(discount) || 0;
                        // Calculate total of all items
                        const totalAmount = items.reduce(
                            (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                            0
                        );
                        // Calculate discount
                        const discountAmount = discountType === 'percent'
                            ? (totalAmount * discountValue / 100)
                            : discountValue;
                        // Calculate the total after discount
                        const totalAfterDiscount = totalAmount - discountAmount;
                        // Calculate the proportion of discount for each item
                        const discountRatio = totalAmount > 0 ? discountAmount / totalAmount : 0;
                        // Calculate tax only on taxable items after proportional discount
                        const taxableAmount = items.reduce(
                            (total, item) => {
                            if (item.item_tax_state) {
                                const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                const itemDiscount = itemTotal * discountRatio;
                                return total + (itemTotal - itemDiscount);
                            }
                            return total;
                            },
                            0
                        );
                        const taxTotal = taxableAmount * (Number(tax_amount) / 100);
                        return numberbeautify(money_rounding(taxTotal));
                    })()}</p>
                </div>
                <div className='w-full flex justify-end py-[5px] px-2' style={{backgroundColor:templatee?.selectedcolor?.secondary}}>
                    <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.tableheadercolor}}>{localizationn?.total}</p>
                    <p className='w-1/2 text-right sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_currencyy?.symbol}
                    {(() => {
                        const items = itemss || [];
                        const discountType = discount_type;
                        const discountValue = Number(discount) || 0;
                        // Calculate subtotal
                        const subtotal = items.reduce(
                            (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                            0
                        );
                        // Apply discount to subtotal
                        const discountt = discountType === 'percent'
                            ? (subtotal * discountValue / 100)
                            : discountValue;
                        const subtotalAfterDiscount = subtotal - discountt;
                        // Calculate how much of the discounted subtotal is taxable
                        const taxableRatio = subtotal > 0 ? subtotalAfterDiscount / subtotal : 0;
                        // Calculate tax only on taxable items after proportional discount
                        const taxTotal = items.reduce(
                            (total, item) => {
                            if (item.item_tax_state) {
                                const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                const itemAfterDiscount = itemTotal * taxableRatio;
                                return total + (itemAfterDiscount * (Number(tax_amount) / 100));
                            }
                            return total;
                            },
                            0
                        );
                        const totalAfterDiscount = subtotalAfterDiscount + taxTotal;
                        return numberbeautify(money_rounding(totalAfterDiscount));
                    })()}</p>
                </div>
                {signature.trim()&&(
                    <div className='mt-[10px] flex flex-col items-center'>
                        <img src={signature} className="scale-[0.8]" contentFit="contain" />
                        <p className="sf-semibold -mt-3 text-[9px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{signature_name}</p>
                    </div>
                )}
            </div>
        </div>

      <div className='w-full h-52' />
    </div>
  )
}

export default Modern_template_2